import { NavSchema } from "./NavSchema";

export const toCurrency = (numberString) => {
  let number = parseFloat(numberString);
  return number.toLocaleString("USD");
};

export const convertDate = (fecha, hora) => {
  let date = fecha;
  let day = (date.getDate() < 10 ? "0" : "") + date.getDate();
  let month = (date.getMonth() < 9 ? "0" : "") + (date.getMonth() + 1);
  let year = date.getFullYear();
  let date2 = hora;
  let hours = date2.getHours();
  let minutes = date2.getMinutes();
  let seconds = date2.getSeconds();
  if (hours < 13) {
    const fecha = `${year}-${month}-${day} ${hours > 9 ? hours : "0" + hours}:${
      minutes > 9 ? minutes : "0" + minutes
    }:${seconds > 0 ? seconds : "0" + seconds}`;
    return fecha;
  } else {
    const fecha = `${year}-${month}-${day} ${hours > 9 ? hours : "0" + hours}:${
      minutes > 9 ? minutes : "0" + minutes
    }:${seconds > 0 ? seconds : "0" + seconds}`;
    return fecha;
  }
};

export const convert = (data) => {
  let date = new Date(data);
  let day = (date.getDate() < 10 ? "0" : "") + date.getDate();
  let month = (date.getMonth() < 9 ? "0" : "") + (date.getMonth() + 1);
  let year = date.getFullYear();
  const fecha = `${year}-${month}-${day}`;
  return fecha;
};

export const objetToArray = (object) => {
  let array = [];

  let properties = Object.keys(object);

  for (let i = 0; i < properties.length; i++) {
    array.push({ idPermiso: object[properties[i]] });
  }
  return array;
};

export const ArrayToObjet = (object) => {
  let array = [];

  let properties = Object.keys(object);

  for (let i = 0; i < properties.length; i++) {
    array.push({ idPermis: object[properties[i]] });
  }
  return array;
};

export const extraerValores = (objeto) => {
  return Object.values(objeto);
};

export const validaArrayPermiso = (objeto) => {
  NavSchema.map((id) => {
    for (let i = 0; i < objeto.length; i++) {
      if (id.idPermiso === objeto[i].idPermiso)
        return [id.name, id.idPermiso, true];
    }
    return [id.name, id.idPermiso, id.check];
  });
};

export const getInfoProducts = (obj, id) => {
  return obj.find((info) => info.specificationName === id);
};

export const toColombianPesos = (value) => {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(value);
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function formatDate(date = new Date()) {
  const year = date.toLocaleString("default", { year: "numeric" });
  const month = date.toLocaleString("default", {
    month: "2-digit",
  });
  const day = date.toLocaleString("default", { day: "2-digit" });

  return [year, month, day].join("-");
}

export function formatDateTime(date = new Date()) {
  const year = date.toLocaleString("default", { year: "numeric" });
  const month = date.toLocaleString("default", {
    month: "2-digit",
  });
  const day = date.toLocaleString("default", { day: "2-digit" });

  const hours = date.toLocaleString("default", { hour: "2-digit" });
  const minutes = date.toLocaleString("default", { hour: "2-digit" });
  const seconds = date.toLocaleString("default", { second: "2-digit" });

  const _date = [year, month, day].join("-");
  const _hours = [hours, minutes, seconds].join(":");

  return [_date, _hours].join(" ");
}

export function formatIntDate(date) {
  if (date.length === 0) return null;

  const year = date.slice(0, 4);
  const month = date.slice(4, 6);
  const day = date.slice(6, 8);

  return `${year}-${month}-${day}`;
}

/**
 * Filters an array of objects using custom predicates.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */

export function genericFilter(
  array,
  filters
) {

  return array.filter(function (item) {
    for (var key in filters) {
      if (item[key] === undefined || item[key] !== filters[key]) return false;
    }
    return true;
  });
}

/**
 * The method `filterArray()` has the following signature:
 *
 * `function filterArray<TInput = any>(array: TInput[], filters: IFilters) => TInput[]`
 *
 * Where the function receives an array as the first argument, and a plain object
 * describing the fields to filter as the last argument.
 * The function returns an array of the same type as the input array.
 *
 * The signature of the filters arguments is the following:
 *
 * `interface IFilters {
 *   [key: string]: (value: any) => boolean;
 * }`
 *
 * Where the `filters` argument is an object that contains a `key: string`
 * and its value is a function with the value of the property to evaluate.
 * As the function predicate is evaluated using the `Array.prototype.every()` method,
 * then it must return a boolean value, which will determine if the item
 * must be included or not in the filtered array.
 */

export function debounce(func, timeout = 2000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function removeDuplicates(arr) {
  let unique = arr.reduce(function (acc, curr) {
    if (!acc.includes(curr)) acc.push(curr);
    return acc;
  }, []);
  return unique;
}
